import React, {useEffect, useState, useRef} from "react";
import { useNavigate } from "react-router-dom";

import GenStyles from "../styles/GenStyles.module.css";
import { talk } from "../ALI_Ajax.js";
import TStyles from "../styles/TestStyles.module.css";
import {useUser} from "../UserContext";
import LoginModule from "../login_module";
import STTStyles from "../styles/STTStyles.module.css";
import {ALI_Recorder} from "../ALI_Recorder.js";
import { log_message } from "../ALI_Logger";
import aiAnimationTransparent from "../images/ai_speaker_image_transparent.png";
import SpeakingTestInterface from "../components/SpeakingTestInterface";
import JsonViewer from "../components/JsonViewer";
import WritingTestInterface from "../components/WritingTestInterface";
import LoadingGif from "../images/loading.gif";
import LoadingBlock from "../components/LoadingBlock";
import TestOverBlock from "../components/TestOverBlock";

const TakeTest = () => {
    const navigate = useNavigate();


    // Security related variables
    const {userId, finishedLoggingIn} = useUser();
    const [whichTest, setWhichTest] = useState("writing");

    // Recording related variables
    const [responseText, setResponseText] = useState(false);
    const [studentTextResponse, setStudentTextResponse] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [recordingUrl, setRecordingUrl] = useState(false);

    // UI related?
    const [notificationMessage, setNotificationMessage] = useState('');

    // Question administration related?
    const [questionTotalTime, setQuestionTotalTime] = useState(30);
    const [questionTimeRemaining, setQuestionTimeRemaining] = useState(30);
    const [currentQuestion, setCurrentQuestion] = useState(null);

    //Test State?
    const [userAndTestId, setUserAndTestId] = useState(22);
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [testState, setTestState] = useState(null);
    const [testSession, setTestSession] = useState(null);

    //Rubric?
    const [rubric, setRubric] = useState(false);


    /** ON LOAD ACTIONS **/

    useEffect(() => {       //ON LOAD
        checkForAvailableQuestion();

        //Create Recording Event Listeners
        const handleRecordingStarted = () => {
            console.log("Recording started event received!");
            // setNotificationMessage("Recording: ");
            // setQuestionTotalTime(currentQuestion['answer_time_allowed']);
            // setQuestionTimeRemaining(currentQuestion['answer_time_allowed']);
            setIsRecording(true);
        };
        const handleRecordingStopped = (event) => {
            console.log("Recording has stopped. Audio URL: ", event.detail.audioURL);
            //setNotificationMessage("Processing");
            setRecordingUrl(ALI_Recorder.processRecording());
            setIsRecording(false)
            setTestState('thinking');
        }
        const handleRecordingTick = (event) => {
            console.log("Timer Tick: " + event.detail.timeRemaining);
            //setNotificationMessage("Recording: " + questionTimeRemaining);
            setQuestionTimeRemaining(event.detail.timeRemaining);
        }

        //Add the Event Listeners
        document.addEventListener("recordingTick", handleRecordingTick);
        document.addEventListener("recordingStarted", handleRecordingStarted);
        document.addEventListener("recordingStopped", handleRecordingStopped);

        // Remopve in Production
        //loadParticularTestSession();

        //Cleanup
        return () => {
            document.removeEventListener("recordingTick", handleRecordingTick);
            document.removeEventListener("recordingStarted", handleRecordingStarted);
            document.removeEventListener("recordingStopped", handleRecordingStopped);
        }
    }, []);
    useEffect(() => {

        if(currentQuestion) {
            console.log("STEP: NEW QUESTION RECEIVED:");
            console.log(currentQuestion);
            //setTestState('speaking');
        }
    }, [currentQuestion])


    // Check for Available Question (call on load)
    const checkForAvailableQuestion = () => {

        console.log("STEP: Checking for Available Question.");
        talk(
            "ali_api/handlers/TestHandler.php",
            "CHECK_FOR_AVAILABLE_QUESTION",
            null,
            checkForAvailableQuestionHandler
        );
    }
    const checkForAvailableQuestionHandler = (operation, sentData, returnData) => {
        console.log(returnData);
        if(returnData['status'] === 'success') {
            if(returnData['message'] === 'new_question') {
                setCurrentQuestion(returnData['data']);

                setWhichTest(returnData['data']['whichTest']);
            } else {
                console.log("ALERT: False request for new question while existing question is active.");
            }
        } else {
            console.log(returnData);
            if(returnData['message'] === 'Test Ended') {
                setTestState("test_ended");
            }
        }
    }

    const saveWritingResponse = (writingResponse) => {

        console.log("STEP: Saving Writing Response");
        talk(
            "./ali_api/handlers/TestHandler.php",
            "SAVE_WRITING_RESPONSE",
            {userId: userId, question: currentQuestion, response: writingResponse},
            saveWritingResponseHandler
        );
    }
    const saveWritingResponseHandler = (operation, sendData, returnData) => {
        console.log("DATA RETURNED FROM SAVING WRITING QUESTION:");
        console.log(returnData);

        if(returnData['status'] === 'success') {
            console.log("success");

            setCurrentQuestion(returnData['data']);
        } else {
            console.log(returnData);
            if(returnData['message'] === 'Test Ended') {
                setTestState("test_ended");
            }
        }
    }



    /**
     * LOAD INITIAL BLANK RUBRIC
     */
    /*const getBlankRubric = () => {
        talk(
            "./ali_api/handlers/TestHandler.php",
            "GET_BLANK_RUBRIC-DELETE-THIS-LATER",
            null,
            getBlankRubricHandler
        );
    }
    const getBlankRubricHandler = (operation, sentData, returnData) => {
        setRubric(returnData['data']);
        console.log(returnData['data']);
        // setRubric(JSON.parse(returnData['data']));
        // console.log(JSON.parse(returnData['data']));
    }*/
    /**
     * LOAD SAVED RUBRIC FOR THE CURRENT SESSION (WILL BE USEFUL FOR CONNECTION ERRORS, RESTARTING TEST)
     */
    /*    const loadSessionRubric = () => {
        talk(
            "./ali_api/handlers/TestHandler.php",
            "LOAD_SESSION_RUBRIC",
            {testSessionId: 'f0317277946185ae511575a8abe77d4e'},
        loadSessionRubricHandler
        );
    }
    const loadSessionRubricHandler = (operation, sentData, returnData) => {
        console.log(returnData);
    }*/


    // const loadParticularTestSession = () => {
    //     console.log("HERE");
    //     talk(
    //         "./ali_api/handlers/TestHandler.php",
    //         "LOAD_PARTICULAR_TEST_SESSION",
    //         null,
    //         loadParticularTestSessionHandler
    //     );
    // }
    // const loadParticularTestSessionHandler = (operation, sentData, returnData) => {
    //     console.log(returnData);
    //     if(returnData['status'] === 'success') {
    //         setTestSession(returnData['data']);
    //     }
    // }


    // DISPLAYING QUESTIONS
    const formatQuestionText = () => {
        if(!currentQuestion || !currentQuestion['question_text']) {
            return '';
        }

        return currentQuestion['question_text'].split("\n").map((line, index) => (
            <p key={index}>{line.trim()}</p>
        ));
    }

    // ENDING QUESTION DISPLAY / STARTING RECORDING
    const handleAudioPlaybackStopped = () => {
        console.log("Playback finished handler in parent component.");

        // Here, check to see if this was the final question (if ->isFinalQuestion === true)... if so, end the test. If not, start recording.
        if(currentQuestion['isFinalQuestion'] !== true) {
            startRecordingStudentResponse();
        } else {
            setTestState("test_ended");
        }


    }
    const startRecordingStudentResponse = () => {
        //Make sure we are safe to start recording... we have a recording time?
        let recordingTime;
        if(currentQuestion && currentQuestion['answer_time_allowed']) {
            const value = currentQuestion['answer_time_allowed'];
            if (!isNaN(value) && Number.isInteger(Number(value))) {
                // It is or can be safely converted to an integer
                recordingTime = Number(value);
            }
        } else {
            recordingTime = 45;
            console.log("Error. No allowed recording time was received. Defaulting to 45 seconds.");
            log_message('ERROR', "In startRecordingStudentResponse() in TakeTest.js - " +
                "No allowed recording time was received. Defaulting to 45 seconds.");
        }

        //TODO: Remove this in production... locks recording time to 5 seconds
        recordingTime = 15;

        ALI_Recorder.init();
        setQuestionTotalTime(recordingTime);
        setQuestionTimeRemaining(recordingTime);
        ALI_Recorder.startRecording(recordingTime);

        setTestState('recording');
    }

    //When the student recording is finished being processed
    useEffect(() => {
        if(recordingUrl) {
            //Upload to Server
            let postData = new FormData();
            // postData.append("pin", "1492");     //TOOD: FIX THIS
            postData.append("student_info", JSON.stringify({
                student_id: userId,
                user_and_test_id: userAndTestId,
                questionNumber: currentQuestion['questionNumber']
            }));
            postData.append("file", ALI_Recorder.get_blob(), "recording.webm");
            talk("./ali_api/handlers/TestHandler.php", "PROCESS_STUDENT_AUDIO_RESPONSE", postData, nextQuestionReceivedHandler);
        }
    }, [recordingUrl])




    //Handle receipt of the next question
    const nextQuestionReceivedHandler = (operation, sentData, returnData) => {
        console.log("Received response from server... should be next question ultimately.");
        console.log(returnData);

        if(returnData['status'] === 'success') {
            setCurrentQuestion(returnData['data']);
        }
    }



    const navigateToHomePage = () => {
        navigate('/');
    }






    /** RENDERING **/
    return (
        <>
            {
                finishedLoggingIn ?
                    <>
                        {userId ?
                            <div className={TStyles.container}>
                                <h1 className={TStyles.title}>Test: {whichTest.charAt(0).toUpperCase() + whichTest.slice(1)}</h1>

                                {/*<JsonViewer data={rubric} />*/}

                                {/*<div>testState: {testState}</div>*/}


                                {currentQuestion ? '' :
                                    <LoadingBlock />
                                }

                                {testState === 'test_ended' ?
                                    <TestOverBlock
                                        onFinish={navigateToHomePage}
                                        whichTest={whichTest}
                                    />
                                    :
                                    whichTest === 'speaking' ? (
                                        <SpeakingTestInterface
                                            state={testState}
                                            questionTotalTime={questionTotalTime}
                                            questionTimeRemaining={questionTimeRemaining}
                                            question={currentQuestion}
                                            handleAudioPlaybackStopped={handleAudioPlaybackStopped}
                                        />
                                    ) : (
                                        <WritingTestInterface
                                            state={testState}
                                            questionTotalTime={questionTotalTime}
                                            questionTimeRemaining={questionTimeRemaining}
                                            question={currentQuestion}
                                            saveResponse={saveWritingResponse}
                                            // handleAudioPlaybackStopped={handleAudioPlaybackStopped}
                                        />
                                    )
                                }



                            </div>
                            : <LoginModule/>}
                    </> :
                    <div>loading</div>
            }
        </>
    )
}

export default TakeTest;